'use strict';

module.exports = '3.11.2';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 26
// module chunks = 0